// A browser can't put an Authorization header on a WebSocket handshake, and the
// query-string alternative leaks the reusable access token into every URL that
// touches the request. So the SPA trades its bearer for a hub-only,
// path-scoped cookie over this POST, and the hub URL carries no credential.
//
// Deliberately plain fetch rather than the shared `send()` helper: browser event delivery is a
// background concern, and `send()` would end the whole session on a 401 and attach
// the impersonation header, so a hub hiccup would sign the user out mid-form.
export const HUB_SESSION_URL = '/api/v1/hub/session'

let inFlight: { token: string; promise: Promise<void> } | null = null

// Concurrency dedupe, not a cache: the entry clears when the request settles, so a
// caller retrying after a rejected cookie always gets a fresh one.
export function issueHubSession(token: string): Promise<void> {
  if (inFlight?.token !== token) {
    const promise = post(token).finally(() => {
      if (inFlight?.promise === promise) inFlight = null
    })
    inFlight = { token, promise }
  }
  return inFlight.promise
}

export async function endHubSession(): Promise<void> {
  inFlight = null
  await fetch(HUB_SESSION_URL, { method: 'DELETE' })
}

async function post(token: string): Promise<void> {
  const response = await fetch(HUB_SESSION_URL, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok)
    throw new Error(`Hub session request failed with ${response.status}`)
}

export function __resetHubSessionForTests(): void {
  inFlight = null
}
